<template>
  <div class="ticket-romancecar mb-foot-1button">
    <h1 class="heading center safe-top">予約失敗</h1>

    <hr />
    <div class="alert-erea warning">
      <!-- 条件指定の場合 -->
      <div v-if="specifyMethod == 'conditions'" class="alert">
        条件にあう座席が確保できませんでした
      </div>
      <!-- 座席指定の場合 -->
      <div v-else-if="specifyMethod == 'seat'" class="alert">
        ご指定の座席に対して、別の予約が入り確保することができませんでした
      </div>
    </div>

    <!-- 条件指定の場合 -->
    <div v-if="specifyMethod == 'conditions'" class="warning-block">
      条件を変更してお試しください
    </div>
    <!-- 座席指定の場合 -->
    <div v-else-if="specifyMethod == 'seat'" class="warning-block">
      大変恐れ入りますが、座席を再度ご指定ください
    </div>

    <div class="foot-button-block">
      <button
        type="button"
        class="button button-primary"
        @click="backToPreviousPage"
      >
        戻る
      </button>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

export default {
  name: "TemplateMfittBookingVacantSeatsError",
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const specifyMethod = route.query.specifyMethod;
    console.log("specifyMethod", specifyMethod);

    // 確認画面へ
    const backToPreviousPage = () => {
      router.go(-4);
    };

    return {
      specifyMethod,
      backToPreviousPage,
    };
  },
};
</script>
<style scoped lang="scss">
.safe-top {
  margin-top: calc(30px + env(safe-area-inset-top, 30px) + 30px);
}
.ticket-romancecar h1.heading.center {
  margin-bottom: 30px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.ticket-romancecar .alert-erea {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  height: 106px;
  margin: 46px 0 26px;
  padding: 0;
  text-align: center;
  color: #ffffff;
  background-color: #e0e0e0;
}
.ticket-romancecar .warning {
  background-color: #ed3838;
}
.ticket-romancecar .warning::before {
  position: absolute;
  content: "";
  width: 46px;
  height: 47px;
  top: -23px;
  left: calc(50% - 23px);
  background-repeat: no-repeat;
}
.ticket-romancecar .warning::before {
  background: url("~@/assets/img/icon/svg/icon-warning.svg");
}
.ticket-romancecar .alert-erea .alert {
  align-self: center;
  font-size: 16px;
  font-weight: bold;
  line-height: 22px;
  margin-top: 23px;
}
.foot-button-block {
  position: fixed;
  z-index: 99;
  left: 0;
  width: 100%;
  bottom: 0;
  background-color: #ffffff;
  padding: 15px 15px 20px 15px;
}
.foot-button-block button {
  width: calc(100% - 30px);
  height: 46px;
  border: none;
  border-radius: 30px;
  background-color: #e0e0e0;
  padding: 10px;
  font-size: 14px;
  font-weight: bold;
  color: #000000;
  box-shadow: var(--defaultBoxShadow);
}
.foot-button-block button:nth-of-type(n + 2) {
  margin-top: 20px;
}
.foot-button-block button.button-primary {
  background-color: #ffb206;
  color: #ffffff;
}
.ticket-romancecar .warning-block {
  margin: 16px 6px 16px;
  font-size: 14px;
  text-align: center;
  line-height: 18px;
  color: #ed2323;
  font-weight: bold;
}
</style>
